module.exports = __webpack_public_path__ + "img/credit-card-01.46bea6c5.svg";